import { Instagram, Facebook, Mail, ArrowUpRight } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative pt-24 sm:pt-32 pb-10 px-5 sm:px-8 lg:px-12 border-t border-white/[0.08] bg-black"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
        <div className="md:col-span-5">
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-4 block">
            ML. Agence Web — France
          </span>
          <p className="text-zinc-400 leading-relaxed max-w-md">
            Une agence web indépendante qui crée des sites pensés pour exister, pour convertir, et pour refléter ce que vous valez vraiment.
          </p>
        </div>

        <div className="md:col-span-3">
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-5 block">
            Contact
          </span>
          <ul className="space-y-3 text-zinc-300">
            <li>
              <a href="mailto:ml.agence04@gmail.com" className="inline-flex items-center gap-2 hover:text-[var(--accent)] transition-colors" data-testid="footer-email">
                <Mail className="w-4 h-4" /> ml.agence04@gmail.com
              </a>
            </li>
            <li>
              <a href="https://calendly.com/ml-agence04/30min" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-[var(--accent)] transition-colors" data-testid="footer-calendly">
                <ArrowUpRight className="w-4 h-4" /> Réserver un audit
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-5 block">
            Suivre
          </span>
          <ul className="space-y-3 text-zinc-300">
            <li>
              <a href="https://www.instagram.com/ml._agence/" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-[var(--accent)] transition-colors" data-testid="footer-instagram">
                <Instagram className="w-4 h-4" /> Instagram
              </a>
            </li>
            <li>
              <a href="https://www.facebook.com/" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-[var(--accent)] transition-colors" data-testid="footer-facebook">
                <Facebook className="w-4 h-4" /> Facebook
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-5 block">
            Sections
          </span>
          <ul className="space-y-3 text-zinc-300">
            <li><a href="/#services" className="hover:text-[var(--accent)] transition-colors">Services</a></li>
            <li><a href="/portfolio" className="hover:text-[var(--accent)] transition-colors">Portfolio</a></li>
            <li><a href="/mockup-gratuit" className="hover:text-[var(--accent)] transition-colors">Aperçu gratuit</a></li>
            <li><a href="/audit" className="hover:text-[var(--accent)] transition-colors">Audit express</a></li>
            <li><a href="/#faq" className="hover:text-[var(--accent)] transition-colors">FAQ</a></li>
          </ul>
        </div>
      </div>

      {/* ML. wordmark */}
      <div className="overflow-hidden border-t border-white/[0.08] pt-10">
        <div
          data-testid="footer-bigtype"
          className="font-display uppercase tracking-tighter leading-none text-5xl sm:text-6xl select-none"
        >
          ML<span className="text-[var(--accent)]">.</span>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mt-10 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">
        <span>© {year} ML. Agence Web — Tous droits réservés.</span>
        <span className="flex flex-wrap items-center gap-x-5 gap-y-2">
          <a href="/mentions-legales" className="hover:text-white transition-colors">Mentions légales</a>
          <a href="/confidentialite" className="hover:text-white transition-colors">Confidentialité</a>
          <a href="/cookies" className="hover:text-white transition-colors">Cookies</a>
          <a href="/espace-client" className="hover:text-white transition-colors">Espace client</a>
        </span>
      </div>
    </footer>
  );
}
